<template>
  <div class="modal mymodal" :id="modalid" tabindex="-1" :aria-labelledby="modalid + 'Label'" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" style='background: #9999FF;padding:2px'>
          <p class="modal-title">Add New User</p>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">

          <table>
          <tr><td>USER</td><td>:</td><td>
             <input id="inpuser01" type="text" placeholder="new userid"
                v-model="userid"></td></tr>

          <tr><td>PASSWORD</td><td>:</td><td>
             <input id="inpuser02" type="text" v-model="password"
                placeholder="password"></td></tr>

          <tr><td>ADMINLVL</td><td>:</td><td>
             <input id="inpuser03" type="text" v-model="adminlvl"
               placeholder="0,1 or 2"></td></tr>
          
          <tr><td>MULTISESSION</td><td>:</td><td>
             <input id="inpuser04" type="text" v-model="multisession"
               placeholder="0 or 1"></td></tr>
          </table>

          <div v-if="errormsg !=''" class="border mb-3" 
              style='color:red;background:yellow'>
              {{errormsg}}
          </div>

          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mymodal > div {
    position: absolute ;
    background-color: yellow;
}
.nomargin {
   margin-block-start: 0 ;
   margin-block-end : 0 ;
}
</style>

<script>
export default {
  name: 'UserModal',
  props: {
    swapid : String,
    script : String,
    modalid : String
  },
  methods : {
  },
  data() {
    return {
      userid : "",
      password : "",
      multisession : "",
      adminlvl : "",
      errormsg : ""
    }
  }
}
</script>
